var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-item-photo",on:{"click":function($event){return _vm.$emit('clickPhoto')}}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgObj),expression:"imgObj"}],staticClass:"photo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }